
import Vue from 'vue';
import { TabItems } from '../types';

interface TabsData {
  tabWidth: string;
}

interface TabsComputed {
  activeTabStyle: Object;
  tabClasses: string;
}

interface TabsProps {
  items: TabItems[];
  activeTab: number;
  type: string;
}

export default Vue.extend<TabsData, {}, TabsComputed, TabsProps>({
  name: 'Tabs',
  computed: {
    activeTabStyle() {
      const width = `(100% - 10px) / ${this.items.length}`;

      return {
        width: `calc(${width})`,
        transform: `translateX(calc(100% * ${this.activeTab}))`
      };
    },
    tabClasses() {
      return `eu-tabs-${this.type}`;
    }
  },
  model: {
    prop: 'activeTab'
  },
  props: {
    /**
     * Item of the array
     * @type {TabItems[]}
     */
    items: {
      type: Array,
      required: true
    },
    /**
     * Active tabs. Start from 0
     */
    activeTab: {
      type: Number,
      required: true
    },
    /**
     * Type of the tabs
     * @value `skeleton` `circular` `button`
     */
    type: {
      type: String,
      default: 'skeleton',
      validator: value => ['circular', 'skeleton', 'button'].includes(value)
    }
  },
  methods: {
    /**
     * Get class name for active tab item
     */
    activeTabItemClass(index: number) {
      return {
        active: index === this.activeTab
      };
    },
    /**
     * Callback function when user click the tab
     */
    handleClickTab(index: number) {
      /**
       * Additional callback when user click the tab
       * @type {function}
       */
      this.$emit('change-tab', index);
      /**
       * Handle when user change the tab (automatically from v-model).
       * @event click
       * @type {function}
       */
      this.$emit('input', index);
    }
  }
});
